import ZZAPP from '@zz-vc/zz-open-libs/lib/libs/adapter'
// // import getQuery from '@zz-vc/zz-open-libs/lib/libs/getQuery'
const qs = require('querystring')
// import isZZ from './isZhuanzhuan.js'
const isWc = navigator.userAgent.indexOf('MicroMessenger') > -1

const isZZ = window.navigator.userAgent.toLowerCase().indexOf('zhuanzhuan') > 0
const waReg = /^(pages)|(subPages)|(\/pages)|(\/subPage)/
const locationRoute = (url, type) => {
  if (type == 'replace') {
    location.replace(url)
  } else {
    location.href = url
  }
}
/**
 * 通用跳转方法
 *
 * Demo
 * 路由跳转：
 * this.$enterPage('/deposit',{
        infoId:111
        price:this.price
   })
   或 url跳转
   this.$enterPage('https://m.zhuanzhuan.com/open/ZZAntiqueTool/index.html#/deposit')

 * @param {*} route  路由名称
 * @param {*} query  参数
 * @param {*} type   跳转类型 默认push当前页 replace替换方式
 * @returns {void}
 */
const enterPage = function (route = '', query = {}, type = 'push') {
  try {
    const params = Object.assign({}, query)
    const url = `${location.origin}${location.pathname}`
    // 如果在转转中，重新打开新的webview
    if (isZZ) {
      // 如果是小程序原生页面的话。用小程序的sdk跳转
      if (waReg.test(route)) {
        const appSkipToMini =
          'zhuanzhuan://jump/core/miniProgram/jump?userName=gh_c2980df66965&path=' +
          encodeURIComponent(route.replace(/^\//, '')) +
          '&miniprogramType=0'

        ZZAPP.enterUnifiedUrl({
          unifiedUrl: appSkipToMini,
          needClose: false
        })
      } else {
        ZZAPP.enterPage({
          targetUrl: route.includes('http')
            ? route
            : url + '?' + qs.stringify(params) + '#' + route,
          needClose: type === 'replace' ? '1' : '0'
        })
      }
    } else {
      //端外环境
      //如果是url
      if (route.includes('http')) {
        // 如果是微信，小程序中重新打开新的webview，微信中用location跳转
        if (isWc) {
          ZZAPP.asyncIn(
            'wa',
            () => {
              ZZAPP.skipToUrl({
                targetUrl: route,
                needClose: type == 'replace'
              })
            },
            () => {
              locationRoute(route, type)
            }
          )
        } else {
          locationRoute(route, type)
        }
      } else if (waReg.test(route)) {
        //小程序页面
        ZZAPP.asyncIn(
          'wa',
          () => {
            ZZAPP.skipToUrl({
              targetUrl: route,
              needClose: type == 'replace'
            })
          },
          () => {
            console.warn('微信浏览器环境不支持打开小程序')
          }
        )
      } else {
        this.$router[type]({
          path: `${route}`,
          query: Object.assign({}, params)
        })
      }
    }
  } catch (e) {
    console.error(e)
  }
}
export default enterPage
